/**
 * Describes the edges > nodes structure of Gatsby GraphQL queries for
 * simplifiying props definitions.
 *
 * T is the actual queried element so a query can be described as:
 *
 *   data: {
 *     allRecipiesQuery: Query<{
 *       name: string
 *     }>
 *   }
 */
export type Query<T> = {
  edges: Array<{
    node: T;
  }>;
};

/**
 * Unwrap the elements from a Gatsby GraphQL query from the given edges > nodes
 * structure which isn't necessary for simple queries, returning the array of
 * resulting objects.
 */
export function unwrapQuery<T>(query?: Query<T> | null): Array<T> {
  // If a query has no results, Gatsby doesn't return a key for that value at
  // all. I think an empty array for an empty query makes a lot more sense, so
  // lets allow this function to quitely handle that.
  if (query == null) {
    return [];
  }
  return query.edges.map((e) => e.node);
}
